export interface RedirectPage {
  save(redirectPage: string): void;
  get(): string;

  delete(): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RedirectPage = Symbol('RedirectPage');
